import {Conversation} from '@stripe-internal/conversations-client';
import {useCallback, useEffect, useState} from 'react';
import {isChannelChat, isChannelRAC} from './conversationUtils';

type Props = {
  conversation: Conversation;
};

export const useLiveChannelStatus = ({conversation}: Props) => {
  const [isChat, setIsChat] = useState<boolean>(false);
  const [isRAC, setIsRAC] = useState<boolean>(false);

  const [agentNames, setAgentNames] = useState<string[]>([]);

  const updateAgentName = useCallback(() => {
    const participants = Object.values(conversation.participants);

    const names = participants
      .filter((p) => p.role === 'agent')
      .map((p) => p.displayName)
      .filter((name) => !!name);

    setAgentNames(names);
  }, [conversation]);

  useEffect(() => {
    updateAgentName();

    const sub = conversation
      .participantsObservable()
      .subscribe(() => updateAgentName());

    return () => sub.unsubscribe();
  }, [conversation, updateAgentName]);

  useEffect(() => {
    setIsChat(isChannelChat(conversation));
    setIsRAC(isChannelRAC(conversation));

    const sub = conversation.contextObservable().subscribe(() => {
      setIsChat(isChannelChat(conversation));
      setIsRAC(isChannelRAC(conversation));
    });

    return () => sub.unsubscribe();
  }, [conversation]);

  return {
    isLiveChatActive: isChat && conversation.isActive,
    isRACActive: isRAC && conversation.isActive,
    agentNames,
  };
};
